<template>
  <q-page padding>
    <!--        <q-alert type="warning" icon="warning" class="q-mb-md">-->
    <!--            <strong>Welcome to AGC MN Beta.</strong><br>-->
    <!--            - Please note, the site is continuously being worked on and your experience may change as we keep adding new features or fix existing features that may not be behaving as we want.<br>-->
    <!--            - Some functionality has been disabled on purpose as its being worked on.<br>-->
    <!--            - New data entries, files, that you upload or add to the beta will be lost.<br>-->
    <!--            - While the data is fairly current, it does not sync with the existing live website.<br>-->
    <!--        </q-alert>-->
    <!--        <q-alert type="warning" icon="warning" class="q-mb-md">-->
    <!--            <strong>Please make sure to refresh your browser <u>often</u> using Crtl + R (Windows) or Command + R (Mac).  This will ensure you are seeing the latest updates.</strong>-->
    <!--        </q-alert>-->
    <q-card class="md-card q-mt-lg q-pa-lg relative-position" color="white" text-color="black">
      <q-card-title>
        AGC MN Dashboard
      </q-card-title>
      <q-card-separator/>
      <q-card-main>
        <div class="row q-mb-lg">
          <div class="col-6 q-pr-sm">
            <q-list highlight>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="check_box" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/pending-approval"> View Company Applications and Edits Pending
                    Approval
                  </q-btn>
                </q-item-main>
              </q-item>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="business" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/company/list"> View/Manage Companies
                  </q-btn>
                </q-item-main>
              </q-item>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="link" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/company/registrationLink"> Create Registration Link
                  </q-btn>
                </q-item-main>
              </q-item>
            </q-list>
          </div>
          <div class="col-6 q-pl-sm">
            <q-list highlight>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="people" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/person/list"> View/Manage People
                  </q-btn>
                </q-item-main>
              </q-item>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="email" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/person/constant-contact"> Send Profile Update Email (Constant
                    Contact)
                  </q-btn>
                </q-item-main>
              </q-item>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="account_circle" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/user/list"> View/Manage Users
                  </q-btn>
                </q-item-main>
              </q-item>
            </q-list>
          </div>
        </div>
        <div class="row">
          <div class="col-6 q-pr-sm">
            <q-list highlight>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="event_available" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/event/list"> View/Manage Events
                  </q-btn>
                </q-item-main>
              </q-item>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="archive" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/contract/list"> View/Manage Contracts
                  </q-btn>
                </q-item-main>
              </q-item>
            </q-list>
          </div>
          <div class="col-6 q-pl-sm">
            <q-list highlight>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="attach_money" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/purchase/list"> View/Manage Purchases
                  </q-btn>
                </q-item-main>
              </q-item>
              <q-item>
                <q-item-side>
                  <q-item-tile icon="account_balance" color="primary"/>
                </q-item-side>
                <q-item-main>
                  <q-btn flat color="primary" to="/quickbooks"> Find Helpful Quickbooks Links
                  </q-btn>
                </q-item-main>
              </q-item>
            </q-list>
          </div>
        </div>
      </q-card-main>
    </q-card>
    <router-view></router-view>
  </q-page>
</template>

<script>
  export default {
    name: 'Entry'
  }
</script>

<style></style>
